import type { AppLocale } from "@/i18n/config";
import { useLocale } from "next-intl";
import { useCallback, useEffect, useState } from "react";

export function useLocaleState(initialLocale: AppLocale = "en") {
  // next-intl's useLocale throws if no provider is present; fall back to initialLocale.
  let activeLocale: AppLocale = initialLocale;
  try {
    activeLocale = (useLocale() as AppLocale) ?? initialLocale;
  } catch {
    activeLocale = initialLocale;
  }
  const [currentLang, setCurrentLang] = useState<AppLocale>(activeLocale);

  useEffect(() => {
    setCurrentLang(activeLocale);
  }, [activeLocale]);

  const changeLocale = useCallback(
    (nextLocale: AppLocale) => {
      setCurrentLang(nextLocale);
    },
    [],
  );

  return { currentLang, setCurrentLang, changeLocale };
}
